import api from './api';

/**
 * سرویس مدیریت مشاوران
 * شامل عملیات برای دریافت لیست مشاوران
 */

// دریافت لیست مشاوران (با پشتیبانی از pagination و جستجو)
export const getConsultants = async (params = {}) => {
  try {
    // استفاده از روت خصوصی با pagination
    const response = await api.get('/users/consultants', { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// دریافت اطلاعات یک مشاور خاص
export const getConsultantById = async (consultantId) => {
  try {
   
    
    // بررسی و تبدیل consultantId
    if (!consultantId) {
      throw new Error('شناسه مشاور الزامی است');
    }
    
    // تبدیل consultantId به string اگر object باشد
    let finalConsultantId = consultantId;
    if (typeof consultantId === 'object' && consultantId !== null) {
      // اگر consultantId شامل consultantId باشد
      if (consultantId.consultantId) {
        finalConsultantId = consultantId.consultantId;
      } else {
        finalConsultantId = consultantId._id || consultantId.id || consultantId.toString();
      }
    }
    
    
    const response = await api.get(`/users/${finalConsultantId}`);
    return response.data;
  } catch (error) {
    console.error('🔍 getConsultantById - error:', error);
    throw error.response?.data || error.message;
  }
};

// ایجاد مشاور جدید (فقط برای مدیران)
export const createConsultant = async (consultantData) => {
  try {
    const response = await api.post('/users', { 
      ...consultantData, 
      role: 'consultant',
      // تبدیل نام و نام خانوادگی به فرمت مورد نیاز
      firstName: consultantData.firstName,
      lastName: consultantData.lastName
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// بروزرسانی اطلاعات مشاور
export const updateConsultant = async (consultantId, consultantData) => {
  try {
  
    
    // بررسی و تبدیل consultantId
    if (!consultantId) {
      throw new Error('شناسه مشاور الزامی است');
    }
    
    // تبدیل consultantId به string اگر object باشد
    let finalConsultantId = consultantId;
    if (typeof consultantId === 'object' && consultantId !== null) {
      // اگر consultantId شامل consultantId و consultantData باشد
      if (consultantId.consultantId) {
        finalConsultantId = consultantId.consultantId;
        // consultantData را از consultantId object استخراج کن
        if (!consultantData && consultantId.consultantData) {
          consultantData = consultantId.consultantData;
        }
      } else {
        finalConsultantId = consultantId._id || consultantId.id || consultantId.toString();
      }
      console.log('🔍 updateConsultant - consultantId converted to:', finalConsultantId);
    }
    
    console.log('🔍 updateConsultant - final consultantData:', consultantData);
    console.log('🔍 updateConsultant - sending request to:', `/users/${finalConsultantId}`);
    
    const response = await api.put(`/users/${finalConsultantId}`, consultantData);
    return response.data;
  } catch (error) {
    console.error('🔍 updateConsultant - error:', error);
    throw error.response?.data || error.message;
  }
};

// حذف مشاور (soft delete - فقط برای مدیران)
export const deleteConsultant = async (consultantId) => {
  try {
 
    
    // بررسی و تبدیل consultantId
    if (!consultantId) {
      throw new Error('شناسه مشاور الزامی است');
    }
    
    // تبدیل consultantId به string اگر object باشد
    let finalConsultantId = consultantId;
    if (typeof consultantId === 'object' && consultantId !== null) {
      // اگر consultantId شامل consultantId باشد
      if (consultantId.consultantId) {
        finalConsultantId = consultantId.consultantId;
      } else {
        finalConsultantId = consultantId._id || consultantId.id || consultantId.toString();
      }
      console.log('🔍 deleteConsultant - consultantId converted to:', finalConsultantId);
    }
    
    console.log('🔍 deleteConsultant - sending request to:', `/users/${finalConsultantId}`);
    
    const response = await api.delete(`/users/${finalConsultantId}`);
    return response.data;
  } catch (error) {
    console.error('🔍 deleteConsultant - error:', error);
    throw error.response?.data || error.message;
  }
};

// جستجو در مشاوران (استفاده از همان روت با پارامتر search)
export const searchConsultants = async (params = {}) => {
  try {
    const response = await api.get('/users/consultants', { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// دریافت آمار مشاور

// دریافت ساعات کاری مشاور
export const getConsultantWorkingHours = async (consultantId, date) => {
  try {

    
    // بررسی و تبدیل consultantId
    if (!consultantId) {
      throw new Error('شناسه مشاور الزامی است');
    }
    
    // تبدیل consultantId به string اگر object باشد
    let finalConsultantId = consultantId;
    if (typeof consultantId === 'object' && consultantId !== null) {
      // اگر consultantId شامل consultantId باشد
      if (consultantId.consultantId) {
        finalConsultantId = consultantId.consultantId;
      } else {
        finalConsultantId = consultantId._id || consultantId.id || consultantId.toString();
      }
      console.log('🔍 getConsultantWorkingHours - consultantId converted to:', finalConsultantId);
    }
    
    console.log('🔍 getConsultantWorkingHours - sending request to:', `/users/${finalConsultantId}/working-hours`);
    
    const response = await api.get(`/users/${finalConsultantId}/working-hours`, {
      params: { date }
    });
    return response.data;
  } catch (error) {
    console.error('🔍 getConsultantWorkingHours - error:', error);
    throw error.response?.data || error.message;
  }
};

// دریافت ساعات خالی مشاور (شامل ساعات کاری و ملاقات‌های موجود)
export const getAvailableTimeSlots = async (consultantId, date) => {
  try {

    
    // بررسی و تبدیل consultantId
    if (!consultantId) {
      throw new Error('مشاور الزامی است');
    }
    
    // تبدیل consultantId به string اگر object باشد
    let finalConsultantId = consultantId;
    if (typeof consultantId === 'object' && consultantId !== null) {
      finalConsultantId = consultantId._id || consultantId.id || consultantId.toString();
      console.log('🔍 getAvailableTimeSlots - consultantId converted to:', finalConsultantId);
    }
    
    // تبدیل تاریخ شمسی به میلادی
    let gregorianDate = date;
    
    if (date && date.includes('/')) {
      const moment = require('moment-jalaali');
      const gregorianMoment = moment(date, 'jYYYY/jMM/jDD');
      
      if (gregorianMoment.isValid()) {
        gregorianMoment.hour(12).minute(0).second(0).millisecond(0);
        gregorianDate = gregorianMoment.format('YYYY-MM-DD');
      }
    }
    
    console.log('🔍 getAvailableTimeSlots - sending request with:', {
      consultantId: finalConsultantId,
      date: gregorianDate
    });
    
    const response = await api.post('/appointments/available-slots', {
      consultantId: finalConsultantId,
      date: gregorianDate
    });
    return response.data;
  } catch (error) {
    console.error('🔍 getAvailableTimeSlots - error:', error);
    throw error.response?.data || error.message;
  }
};
export const getConsultantStats = async (consultantId) => {
  try {

    
    // بررسی و تبدیل consultantId
    if (!consultantId) {
      throw new Error('شناسه مشاور الزامی است');
    }
    
    // تبدیل consultantId به string اگر object باشد
    let finalConsultantId = consultantId;
    if (typeof consultantId === 'object' && consultantId !== null) {
      // اگر consultantId شامل consultantId باشد
      if (consultantId.consultantId) {
        finalConsultantId = consultantId.consultantId;
      } else {
        finalConsultantId = consultantId._id || consultantId.id || consultantId.toString();
      }
      console.log('🔍 getConsultantStats - consultantId converted to:', finalConsultantId);
    }
    
    console.log('🔍 getConsultantStats - sending request to:', `/users/${finalConsultantId}/stats`);
    
    const response = await api.get(`/users/${finalConsultantId}/stats`);
    return response.data;
  } catch (error) {
    console.error('🔍 getConsultantStats - error:', error);
    throw error.response?.data || error.message;
  }
};

// دریافت ساعات کاری مشاور
export const getWorkingHours = async (consultantId) => {
  try {
  
    
    // بررسی و تبدیل consultantId
    if (!consultantId) {
      throw new Error('شناسه مشاور الزامی است');
    }
    
    // تبدیل consultantId به string اگر object باشد
    let finalConsultantId = consultantId;
    if (typeof consultantId === 'object' && consultantId !== null) {
      // اگر consultantId شامل consultantId باشد
      if (consultantId.consultantId) {
        finalConsultantId = consultantId.consultantId;
      } else {
        finalConsultantId = consultantId._id || consultantId.id || consultantId.toString();
      }
      console.log('🔍 getWorkingHours - consultantId converted to:', finalConsultantId);
    }
    
    console.log('🔍 getWorkingHours - sending request to:', `/users/${finalConsultantId}/working-hours`);
    
    const response = await api.get(`/users/${finalConsultantId}/working-hours`);
    return response.data;
  } catch (error) {
    console.error('🔍 getWorkingHours - error:', error);
    throw error.response?.data || error.message;
  }
};

// بروزرسانی ساعات کاری مشاور
export const updateWorkingHours = async (consultantId, workingHoursData) => {
  try {

    
    // بررسی و تبدیل consultantId
    if (!consultantId) {
      throw new Error('شناسه مشاور الزامی است');
    }
    
    // تبدیل consultantId به string اگر object باشد
    let finalConsultantId = consultantId;
    if (typeof consultantId === 'object' && consultantId !== null) {
      // اگر consultantId شامل consultantId باشد
      if (consultantId.consultantId) {
        finalConsultantId = consultantId.consultantId;
      } else {
        finalConsultantId = consultantId._id || consultantId.id || consultantId.toString();
      }
      console.log('🔍 updateWorkingHours - consultantId converted to:', finalConsultantId);
    }
    
    console.log('🔍 updateWorkingHours - sending request to:', `/users/${finalConsultantId}/working-hours`);
    
    const response = await api.put(`/users/${finalConsultantId}/working-hours`, workingHoursData);
    return response.data;
  } catch (error) {
    console.error('🔍 updateWorkingHours - error:', error);
    throw error.response?.data || error.message;
  }
};

// دریافت ساعات غیرفعال مشاور (اختیاری: فیلتر ماه شمسی با year, month)
export const getUnavailableSlots = async (consultantId, params = {}) => {
  try {
    if (!consultantId) throw new Error('شناسه مشاور الزامی است');
    const finalId = typeof consultantId === 'object' && consultantId != null
      ? (consultantId._id || consultantId.id || consultantId.toString())
      : consultantId;
    const response = await api.get(`/users/${finalId}/unavailable-slots`, { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// بروزرسانی ساعات غیرفعال مشاور (فقط مدیر/مدیرکل)
export const updateUnavailableSlots = async (consultantId, unavailableSlots) => {
  try {
    if (!consultantId) throw new Error('شناسه مشاور الزامی است');
    const finalId = typeof consultantId === 'object' && consultantId != null
      ? (consultantId._id || consultantId.id || consultantId.toString())
      : consultantId;
    const response = await api.put(`/users/${finalId}/unavailable-slots`, {
      unavailableSlots: unavailableSlots.map(s => ({
        date: s.date,
        startTime: s.startTime,
        endTime: s.endTime
      }))
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
}; 